var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-type":_vm.context.type}},[_c('div',[_c('a',{staticClass:"text-blue-400",attrs:{"href":_vm.context.value}},[_vm._v(_vm._s(_vm.context.value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }